import { environment, GiftCertificateClient } from "@nbly/api-clients";
import { apiConfig } from '../config';

environment.coreApiClientFactory.axiosConfig.baseURL = apiConfig.coreApiBaseUrl;

export const giftCertificateClient = new GiftCertificateClient(environment.coreApiClientFactory);